import recentScoresFetchEpic from "./recent-scores-fetch";
import { combineEpics } from "redux-observable";

export default combineEpics(recentScoresFetchEpic);
